import { FolderOpen } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const workflowTaskCategoryOptions: ComboboxFilterOption<string>[] = [
  { label: 'Submission', value: 'submission' },
  { label: 'Payment', value: 'payment' },
  { label: 'Autopay', value: 'autopay' },
]

const WorkflowTaskCategoryFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = workflowTaskCategoryOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Task Category', options: filteredOptions || [] },
        ]}
        placeholder='Search task categories to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={workflowTaskCategoryOptions || []}
          noSelectionText='Task Category'
          pluralIdentifier='task categories'
        >
          <FolderOpen size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default WorkflowTaskCategoryFilter
